import React from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from 'react-highcharts';
import highchartsMore from 'highcharts-more';
import hce from 'highcharts-custom-events';

highchartsMore(ReactHighcharts.Highcharts);
hce(ReactHighcharts.Highcharts);

const defaultChartProperties = {
  credits: {
    enabled: false,
  },
};

const Chart = ({ afterRender = () => {}, config }) => (
  <ReactHighcharts
    config={{ ...defaultChartProperties, ...config }}
    callback={afterRender}
    isPureConfig
  />
);

Chart.propTypes = {
  config: PropTypes.shape({}),
  afterRender: PropTypes.func,
};

export default Chart;
